import type ScreenBase from "@frui.ts/screens/dist/structure/screenBase";
import type { IModuleViewModel } from "../viewModels/types";

export function isModuleViewModel<TViewModel extends ScreenBase>(viewModel: any): viewModel is IModuleViewModel<TViewModel> {
  return viewModel.children?.length > 0 && viewModel.activeChild && viewModel.name;
}
